import RequestV2 from './request-v2';

export default class FreightRateHttpService {
    private static uri = 'freight/config';

    public static getFreightRates(params: any) {
        return RequestV2.get(`${this.uri}`, params);
    }

    public static async saveFreightRate(rate: any) {
        return RequestV2.post(`${this.uri}`, rate);
    }

    public static async editFreightRate(rate: any) {
        return RequestV2.put(`${this.uri}`, rate);
    }

    public static async deleteFreightRate(id?: number) {
        return RequestV2.del(`${this.uri}/${id}`);
    }
}
